export default from './WebHeader';



// WEBPACK FOOTER //
// ./src/components/WebHeader/index.js